import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PriceService {

  getSpotPriceForCurrencyPair(spotPrices: any, currencyMappings: Array<any>, cp: string) {
    if (!spotPrices) {
      return null;
    }
    const mapping: any | null = currencyMappings.find(item => item[0].toUpperCase() === cp.toUpperCase());
    const spotPrice = spotPrices[mapping ? mapping[1] : cp];
    if (!spotPrice) {
      const invertedPrice = spotPrices[cp.slice(3, 6) + cp.slice(0, 3)];
      return invertedPrice ? 1 / invertedPrice : null;
    }
    return spotPrice;
  }
}
